export const CustomerCardToggle = () => {
	const customerCards = document.querySelectorAll('.customers-listing');
	if (customerCards) {
		for (let i = 0; i < customerCards.length; i++) {
			customerCards[i].addEventListener('click', function () {
				this.classList.toggle('active');
				Array.from(customerCards)
					.filter((item) => item !== this)
					.forEach((item) => item.classList.remove('active'));
			});
		}
	}
};
